import {
  authorization,
  authorizationSave,
  authorizationDelete,
  authorizationGet,
  isSetToken,
  userName
} from "@/api/users.api";

import { AUTHORIZATION, SET_LOGIN, LOGOUT } from "../type";

const state = {
  auth: authorizationGet(),
  login: userName(),
  isUsedToken: isSetToken()
};

const getters = {
  getUsers(state) {
    return state.auth;
  }
};
const actions = {
  async [AUTHORIZATION]({ commit }, user) {
    try {
      commit(SET_LOGIN, user.login);
      const response = await authorization(user.login, user.password);
      commit(AUTHORIZATION, response.data);
      return response.status;
    } catch (err) {
      commit(LOGOUT);
      return err.response.status;
    }
  }
};

const mutations = {
  [AUTHORIZATION](state, auth) {
    state.auth = auth;
    authorizationSave(auth);
    state.isUsedToken = isSetToken(auth);
  },
  [LOGOUT](state) {
    state.auth = null;
    authorizationDelete();
    state.isUsedToken = false;
  },
  [SET_LOGIN](state, login) {
    state.login = login;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
